/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const ExpandX = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M10.1778 6.29792L4.18784 12.2878L10.1778 18.2777L9.19575 19.2598L3.20583 13.2698C2.66348 12.7275 2.66349 11.8482 3.20583 11.3058L9.19575 5.31591L10.1778 6.29792ZM13.8811 18.2216L19.871 12.2317L13.8811 6.24177L14.8631 5.25977L20.853 11.2497C21.3954 11.792 21.3954 12.6713 20.853 13.2137L14.8631 19.2036L13.8811 18.2216Z"
                        fill={color}
                    />
                </svg>
        );
    };
